











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { InquiryKind } from '@ajax/modules/services/inquiry'
import ArrivalNotification from '@ajax/vue/components/organisms/ArrivalNotification.vue'

@Component({
  components: {
    ArrivalNotification,
  },
})
export default class Newstock extends Vue {
  @Prop()
  id: string

  @Prop({ required: true })
  brandEnglishName: string

  @Prop({ required: true })
  isLineAccountAssociated: boolean

  @Prop({ default: false })
  useLargeButton: boolean

  get inquiryKind(): InquiryKind {
    return 'new_stock'
  }
}
